import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'merchant-create-employee',
  templateUrl: './merchant-create-employee.component.html',
  styleUrls: ['./merchant-create-employee.component.scss']
})
export class MerchantCreateEmployeeComponent {
  @Output() showMerchantEmployees = new EventEmitter<boolean>();

  public addEmployee(){
    this.showMerchantEmployees.emit(true);
  }
}
